/**
 * Authentication related constants
 */

/**
 * SMS OTP resend countdown duration in seconds (4 minutes)
 * @type {number}
 */
export const RESEND_COUNTDOWN_DURATION = 240;

/**
 * localStorage key for SMS state
 * @type {string}
 */
export const SMS_STATE_KEY = 'sms_state';
